<template>
  <div id="app">
    <link rel="stylesheet" href="https://cdn.materialdesignicons.com/2.0.46/css/materialdesignicons.min.css">
    <Listings msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>

import Listings from './components/listings_map/index.vue'

export default {
  name: 'App',
  components: {
    Listings
  }
}
</script>

<style>
#app {

}
</style>
